import React, { useEffect, useState } from 'react';
import { ToggleButton } from '@lf/ui-primitives';
import {
  getEmailSubscription,
  updateEmailSubscription,
} from '../../api/lfApiEmailSubscription';

const EmailSubscriptions = ({ childProfile }) => {
  const [prefs, setPrefs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const childId = childProfile?.id;

  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (!childId) {
        return;
      }
      setIsLoading(true);
      const data = await getEmailSubscription(childId);
      if (cancelled) {
        return;
      }
      setPrefs(data || {
        summary_subscribed: true,
        inactivity_subscribed: true,
      });
      setIsLoading(false);
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [childId]);

  const onToggle = async (field, value) => {
    if (isSaving) {
      return;
    }
    const next = { ...prefs, [field]: value };
    setPrefs(next);
    setIsSaving(true);
    const saved = await updateEmailSubscription(childProfile.id, {
      [field]: value,
    });
    if (saved) {
      setPrefs(saved);
    } else {
      setPrefs((current) => ({ ...current, [field]: !value }));
    }
    setIsSaving(false);
  };

  if (!childProfile || !childProfile.id) {
    return null;
  }

  const firstName = childProfile.first_name || 'this child';

  return (
    <div className="my-6 max-w-screen-sm py-4">
      <h1 className="text-xl font-semibold pb-2">Email preference</h1>
      {isLoading || !prefs ? (
        <div className="text-sm text-gray-500">Loading…</div>
      ) : (
        <div className="flex flex-col gap-3">
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="font-medium">Daily learning summary</div>
              <div className="text-sm text-gray-500">
                A short recap of what {firstName} watched and learned each day.
              </div>
            </div>
            <ToggleButton
              isToggled={!!prefs.summary_subscribed}
              setIsToggled={(v) => onToggle('summary_subscribed', v)}
            />
          </div>
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="font-medium">Inactivity reminders</div>
              <div className="text-sm text-gray-500">
                Gentle nudges when {firstName} hasn&apos;t been on Learnforest in
                a while.
              </div>
            </div>
            <ToggleButton
              isToggled={!!prefs.inactivity_subscribed}
              setIsToggled={(v) => onToggle('inactivity_subscribed', v)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailSubscriptions;
